import React from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { NavLink } from "react-router-dom";
import { Game } from '../../Components/Game/Game.jsx';
import { GameDetails } from '../../Components/Game/GameDetails.jsx';

export class CasinoIzazovi extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: ['Izazovi', 'Što su izazovi?'],
            selectedTab: 'Izazovi',
            achievements: null,
            achievementsFinished: null,
            achievement: null,
            games: [],
            categories: [],
            achievementNotFound: false,
            loaded: false,
            apiSuccess: true
        }

        casino.utils.createPageGoogleTagManagerEvent('Casino Izazovi', '', 'casino', this.props.user);
        this.arrowBack = this.arrowBack.bind(this);
        this.setGameData = this.setGameData.bind(this);
        this.dohvatiIgre = this.dohvatiIgre.bind(this);
        this.renderIgra = this.renderIgra.bind(this);
        this.gameContainer = React.createRef();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        let achievementId = this.props.route.match && this.props.route.match.params && this.props.route.match.params.achievementId;
        this.props.showMenuFn(false);
        this.getData(achievementId ? achievementId : '');
    }

    componentDidUpdate(prevProps) {
        let achievementId = this.props.route.match && this.props.route.match.params && this.props.route.match.params.achievementId;
        if (prevProps.user !== this.props.user && this.props.user != null) {
            this.getData(achievementId ? achievementId : '');
        }
    }

    arrowBack() {
        window.scrollTo(0, 0);
        history.pushState({}, null, 'casino-izazovi');
        if (this.state.achievements && this.state.achievements.length < 2)
            this.getData('');
        this.setState({ achievement: null });
    }

    addDefaultSrc(e) {
        e.target.src = 'https://cdn.supersport.hr/CasinoIzazovi/default.jpg'
    }

    //Briše childove neispunjenih izazova
    removeChilds(item, activeAchievements, inActiveAchievements, callback) {
        if (!activeAchievements)
            return;

        let activeChild = activeAchievements.find(x => x.dependantOn.some(it => it.achievementID == item.id));

        if (activeChild) {
            activeAchievements = activeAchievements.filter(x => x.id != activeChild.id);
            inActiveAchievements.unshift(activeChild);
            this.removeChilds(activeChild, activeAchievements, inActiveAchievements, callback)
        } else {
            callback({ activeAchievements: activeAchievements, inActiveAchievements: inActiveAchievements });
        }
    }

    filterAchievements(achievementsData) {
        let activeAchievements = [];
        let inActiveAchievements = [];

        achievementsData.forEach(x => {
            if (x.percentage.issued == 0 && !x.isNotAchieved && (Date.now() < new Date(x.endDate).getTime())) {
                //Ako ovisi o drugom izazovu
                if (x => x.dependantOn && x.dependantOn.length > 0 && x.isActive)
                    x.isDepended = true;
                else {
                    x.isDepended = false;
                }
                activeAchievements.push(x);
            } else
                inActiveAchievements.push(x);
        });

        inActiveAchievements.filter(x => x.percentage && x.percentage.issued == 0).forEach(x => {
            if (activeAchievements) {
                this.removeChilds(x, [...activeAchievements], [...inActiveAchievements], (result) => {
                    activeAchievements = result.activeAchievements;
                    inActiveAchievements = result.inActiveAchievements;
                });
            }
        });

        //Sort
        inActiveAchievements = inActiveAchievements.sort((a, b) => new Date(a.endDate) > new Date(b.endDate) ? -1 : 1);
        activeAchievements = activeAchievements.sort((a, b) => new Date(a.startDate) < new Date(b.startDate) ? -1 : 1);

        return { activeAchievements: activeAchievements, inActiveAchievements: inActiveAchievements }
    }

    getData(achievementId) {
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn)]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setGameData, function (reason) { });

        casino.repos.sessionRepo.get().then(result => {
            if (result.igrac) {
                casino.repos.casinoAchievementsCLRepo.get(achievementId).then((achievementsData) => {

                    if (achievementsData.success) {

                        let achievements = this.filterAchievements(achievementsData.achievements)

                        this.setState({
                            achievements: achievements.activeAchievements,
                            achievementsFinished: achievements.inActiveAchievements,
                            achievement: achievementId && achievementsData.achievements[0] != null ? achievementsData.achievements[0] : null,
                            achievementNotFound: achievementId && achievementsData.achievements.length == 0,
                            loaded: true
                        });
                    } else {
                        this.setState({ apiSuccess: false });
                    }
                    this.props.showLoadingFn(false);
                });
            }
            else {
                this.setState({ loaded: true });
                this.props.showLoadingFn(false);
            }
        });
    }

    setGameData(data) {
        var [games, categories] = data;
        this.setState({
            games: games,
            categories: categories.items,
        });
    }

    selectAchievement(achievementId) {
        window.scrollTo(0, 0);
        history.pushState({}, null, 'casino-izazovi/' + achievementId);
        if (this.state.achievements)
            this.setState({ achievement: this.state.achievements.filter(x => x.id == achievementId)[0] });
        else
            this.getData(achievementId);
    }

    filterGames(utrkaIgraSifre) {
        var games = this.props.games;

        if (games) {
            var utrkaIgraSifreArray = utrkaIgraSifre.split(',');
            return games.filter(function (igra) {
                if (utrkaIgraSifreArray.includes(igra.s))
                    return igra;
            });
        }
    }

    dohvatiIgre() {
        var achievementGameIds = this.state.achievement.games;

        return this.state.games.filter(function (igra) {
            if (achievementGameIds.includes(igra.id))
                return igra;
        });
    }

    renderPopisIgara() {
        setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);
        return <div>
            <div className="title">Popis igara</div>
            <div id="game-container" className="maximum margin-center" ref={this.gameContainer}>
                <br></br>
                <div className={"clearfix white games-container"} style={(this.state.games && this.state.selectedCategoryId == -1) ? { padding: '0px' } : {}} >
                    {!this.state.games && <div>Dohvaćanje igara...</div>}
                    {this.state.games && this.dohvatiIgre().map(this.renderIgra)}
                </div>
            </div>
        </div>
    }

    renderIgra(igra, i) {
        return <Game brands={this.props.brands} categories={this.state.categories} routePrefix={"/casino-izazovi/" + this.state.achievement.id} ref={"game-" + igra.id} key={igra.s} igra={igra} showJackpot={true} goLazyImage={true} fromNative={casino.config.fromNativeApp} />;
    }

    renderContent() {
        return <div>
            <div className="segment v2">
                {this.state.tabs && this.state.tabs.map((tab) =>
                    <button key={tab} onClick={() => this.setState({ selectedTab: tab })} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
            </div>
            {this.state.selectedTab === 'Izazovi' && this.renderAchievements()}
            {this.state.selectedTab === 'Što su izazovi?' && this.renderInformacije()}
        </div>
    }

    renderInformacije() {
        return <div>
            <div className="casino-izazovi-info">

                {/*Tu treba napraviti novi design-info*/}

                <div className="content-container">
                    <div className="category-title">Što su Casino izazovi?</div>
                    <div className="info-top">
                        <b className="info-bold">
                            Zaigraj omiljene igre i osvoji posebne nagrade za svoja postignuća!
                        </b>
                    </div>
                    <div className="info-container">
                        <div className="img" />
                        <p className="info-text">
                            Casino izazovi su zabavni zadaci koje možeš izvršiti dok igraš određene Casino igre. Popis i detalje zadataka možeš pronaći s lijeve strane, a za svaki zadatak koji ispuniš, osvajaš i posebnu nagradu. Izazivamo te na zabavu! Igraš?  <br /> <b>Zaigraj!</b>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    }

    renderAchievement(achievement, index, isNotAchieved) {
        let imgUrl = 'https://cdn.supersport.hr/CasinoIzazovi/' + casino.utils.removeAllSpacesFromString(achievement.name) + '.jpg';

        return (<React.Fragment key={index}>
            <div className="izazov-item">
                <div className="icon-container">
                    <span className={'icon-states ' + (achievement.percentage.issued ? 'finished' : achievement.isActive ? 'active' : isNotAchieved ? 'not-achieved' : '')}></span>
                    <img className="izazov-icon" src={imgUrl} onError={this.addDefaultSrc} />
                </div>
                <div className="izazov-info-container">
                    <div className="izazov-info-title">{achievement.name}</div>
                    <div className="izazov-info-duration">
                        Trajanje:&nbsp;
                        <span className="red">
                            {casino.utils.dateToShortDateString(new Date(achievement.startDate))}. {casino.utils.dateToTimeString(new Date(achievement.startDate))}h - {casino.utils.dateToShortDateString(new Date(achievement.endDate))}. {casino.utils.dateToTimeString(new Date(achievement.endDate))}h
                        </span>
                    </div>
                    <div className="description" dangerouslySetInnerHTML={{ __html: achievement.description }} />
                    {this.state.achievement && <div className="pravila-izazov">
                        Pravila promocije SuperCasino izazov možete pronaći na poveznici <a href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/Pravila_SuperCasino_Izazov.pdf?c=${casino.config.guiCacheVerzija}`} target="_blank">PRAVILA.</a>
                    </div>}
                    <div className="progress-bar">
                        <div className="progress">
                            {<div className="bar" style={{ width: + (achievement.percentage.issued ? 100 : achievement.percentage.percentageComplete) + '%' }}></div>}
                        </div>
                    </div>
                </div>
                {achievement.percentage.issued || achievement.percentageComplete == 100 || isNotAchieved ?
                    <div className={"bonus-icon-container " + (isNotAchieved ? 'not-achieved' : '')}>
                        <span className="check"></span>
                        <div className="reward-container">
                            <div className="reward">
                                <br /><b>{!achievement.rewards || achievement.rewards && !achievement.rewards[0] ? 'RAZINA' : 'BONUS'}</b>
                                <br /> {!isNotAchieved ? <span> OSVOJEN 🏆</span> : <span style={{ fontWeight: "800" }}>NEOSVOJEN</span>}
                            </div>
                        </div>
                    </div> :
                    <div className="bonus-container">
                        <div className="bonus-icon-container">
                            <span className="coin"></span>
                            <div className="reward-container">
                                <div className="reward">
                                    {achievement.rewards && achievement.rewards[0] ? achievement.rewards[0].description.toLowerCase() == 'spinova' ? achievement.rewards[0].value : casino.utils.switchEurToKn(achievement.rewards[0].value) : ''}
                                    <div><b>{achievement.rewards && achievement.rewards[0].description && achievement.rewards[0].description.toLowerCase() == 'spinova' ? achievement.rewards[0].description : casino.utils.switchCurrencyKnToEur()}</b></div>
                                </div>
                            </div>
                        </div>
                        {!this.state.achievement ? < button onClick={() => this.selectAchievement(achievement.id)} className="bonus-btn">ODIGRAJ</button> : ''}
                    </div>}
            </div>
            {this.state.achievement && this.state.achievement.games.length > 0 && this.renderPopisIgara()}
            <div className="separator-line"></div>
        </React.Fragment>)
    }

    renderLockedAchievement(achievement, achievementsDependentOn, index) {
        if (!achievement || !achievementsDependentOn)
            return;

        return <div className="izazov-zakljucan">
            <div className="icon-container">
                <img className="icon-img" src="https://cdn.supersport.hr/CasinoIzazovi/zakljucaniIzazov.png" />
            </div>

            <div className="info-container">
                <div className="information">
                    Izvrši {achievementsDependentOn && achievementsDependentOn.map((item, index) => {
                        return item.name + (achievementsDependentOn.length > 0 && index < achievementsDependentOn.length - 1 ? ', ' : '')
                    })} da bi se otključao {achievement.name}
                </div>
                <div className="first-bar"></div>
                <div className="second-bar-container">
                    <div className="first"></div>
                    <div className="second"></div>
                </div>
                <div className="third-bar"></div>
                <div className="fourth-bar"></div>
                <div className="separator-line"></div>
            </div>
        </div>
    }

    renderFinishedAchievements(item, index) {
        if (this.state.achievementsFinished.length == 0) return null;
        return <>
            <div className="title">Završeni izazovi</div>
            {this.state.achievementsFinished.map((achievement, index) => {
                return !achievement.percentage.issued ? this.renderAchievement(achievement, index, true) : this.renderAchievement(achievement, index);
            })}
        </>
    }

    renderAchievements() {
        return <div>
            {(!this.state.achievement && !this.state.achievementNotFound && this.state.achievements.length > 0) && <div className="neodigrani">Broj neodigranih izazova: <span>{this.state.achievements.length}</span></div>}
            {this.state.achievement && <>
                <div className="izazov-title">
                    <span className="arrow-back" onClick={this.arrowBack} ></span>
                    <span className="text">{this.state.achievement.name}</span>
                </div>
            </>}
            <div className="separator-line"></div>
            {/*Izazovi igrača*/}
            {!this.state.achievement && this.state.achievements && this.state.achievements.map((achievement, index) => {
                if (achievement.dependantOn && achievement.dependantOn.length > 0) {
                    let achievementsDependentOn = this.state.achievements && this.state.achievements.filter(x => achievement.dependantOn.some(y => y.achievementID == x.id && y.linkType == 'Must'));
                    let achievementDependentOn = achievementsDependentOn[0];
                    if (achievementDependentOn && achievementDependentOn.percentage && !achievementDependentOn.percentage.issued)
                        return this.renderLockedAchievement(achievement, achievementsDependentOn, index);
                    else
                        return this.renderAchievement(achievement, index);
                } else
                    return this.renderAchievement(achievement, index);
            })}

            {/*Nema izazova*/}
            {this.state.achievements && this.state.achievements.length == 0 && !this.state.achievementNotFound &&
                <div className="no-achievements">
                    <img src="content/images/casinoizazovi/no_active_challenges_artwork.png" />
                    <div>Uskoro te očekuju Super uzbudljivi Casino izazovi!</div>
                </div>}

            {/*Završeni izazovi*/}
            {!this.state.achievement && this.state.achievementsFinished && this.renderFinishedAchievements()}

            {/*Odabrani izazov - Detalji*/}
            {this.state.achievement && this.renderAchievement(this.state.achievement, 0, false)}

            {/*Izazov ne postoji */}
            {this.state.achievementNotFound &&
                <div className="izazov-item">
                    <div className="izazov-info-container">
                        <div className="izazov-info-title"> Izazov više nije aktivan!</div>
                    </div>
                </div>}

        </div>
    }

    renderForAnonymousUser() {
        return <div>
            <div className="title">Prijavi se kako bi vidio Aktivne Izazove!</div>
            <div className="actions">
                {!casino.config.fromNativeApp && <NavLink to={{ pathname: this.props.getHomePathFn(this.props.route.location, '/login'), state: { from: this.props.route.location.pathname } }} className="login-btn">Prijavi se</NavLink>}
                {casino.config.fromNativeApp && <button className="login-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Prijavi se i zaigraj</button>}
                <button className="registration-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Registriraj se</button>
            </div>
            <div className="divider"></div>
            {this.renderInformacije()}
        </div>
    }

    renderLoading() {
        return <div>
            <div className="rectangle-1 half left tab"></div>
            <div className="rectangle-1 half right tab"></div>
            <div style={{ 'clear': 'both' }}></div>
            <div className="rectangle-1"></div>
            <div className="rectangle-2"></div>
            <div className="rectangle-1 full"></div>
            <div className="rectangle-1 half left"></div>
            <div className="rectangle-1 half right red"></div>
            <div style={{ 'clear': 'both' }}></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-3"></div>
        </div>
    }

    render() {
        return <div>
            <MetaTags title="Casino izazovi - SuperSport CASINO" description={"Zaigraj casino izazove u SuperSport CASINU!"} />
            <Header key="header" {...this.state} {...this.props} disableBrowserBack={true}></Header>
            <div className="casino-izazovi-baner">
                <div className="img"></div>
                <div className="big-title">CASINO IZAZOVI</div>
            </div>
            <div id="page-wrapper" className="no-padding grey">
                <div className="casino-izazovi-container maximum margin-center" >
                    {this.props.user && !this.state.achievements && this.state.apiSuccess && this.renderLoading()}
                    {this.props.user && this.state.achievements && this.state.apiSuccess && this.renderContent()}
                    {!this.props.user && this.state.loaded && this.state.apiSuccess && this.renderForAnonymousUser()}
                    {this.props.user && !this.state.apiSuccess && <div>Trenutno ne možemo dohvatiti izazove, molimo pokušajte kasnije...<br /><br /></div>}
                    <div className="res-info"><i>*rezultati se osvježavaju svakih 15 sekundi</i></div>
                </div>
            </div>
            <GameDetails routePrefix={"/casino-izazovi/" + (this.state.achievement?.id || '')} loadGames={true} {...this.props} {...this.state}></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>
    }
}